// extracted by mini-css-extract-plugin
module.exports = {"InputStyle":"Inputs_InputStyle__2tjWT"};